import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const FieldDescriptionInheritedFragmentGql: DocumentNode = gql`
fragment FieldDescriptionInheritedFragment on Field {
  description
  descriptionInherited {
    assetId
    attribute
    value
    distance
    edges
    asset {
      id
      __typename
      ... on Column {
        name
        table {
          id
          name
        }
      }
      ... on Field {
        name
        datasource {
          id
          name
          __typename
          ... on PublishedDatasource {
            vizportalUrlId
          }
        }
      }
    }
  }
}`;
